import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Cascader} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Cascader, {
            'data': this.get('data'),
            'filterable': true,
            'ev-$model:value': function($v) {
                $this.set('value', $v);
            },
            'value': $this.get('value')
        }),
        _$ce(2, 'br'),
        _$ce(2, 'br'),
        _$cc(Cascader, {
            'data': this.get('data'),
            'filterable': true,
            'multiple': true,
            'ev-$model:value': function($v) {
                $this.set('values', $v);
            },
            'value': $this.get('values')
        })
    ], 4);
};